import {Injectable} from '@angular/core';
import { NgbDate, NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

/**
 * @Description : Format input date depending of the user chosen language
 * @UseWith : ngbDatepicker
 * @usedIn : - Visa-start
 *
 */

export class DateReformatSharedService extends NgbDateParserFormatter {

  placeholder;

  constructor(
    private translate: TranslateService,
    ) { super();
        if (this.translate.currentLang === 'en') {
          this.placeholder = 'MM/dd/YYYY';
        }
        else {
          this.placeholder = 'dd/MM/YYYY';
        }
  }




  readonly DELIMITER = '/';

  // Set the input value format
  parse(value: string): NgbDateStruct | NgbDate | null {
    if (value) {
      if (value.length === 2 || value.length === 5) {
        value += this.DELIMITER;
      }
      const date = value.split(this.DELIMITER);
      if (date[0].length !== 2 || date[1].length !== 2 || date[2].length !== 4) {
        return null;
      }
      if (this.translate.currentLang === 'en') {
          return {
            month: parseInt(date[0], 10),
            day: parseInt(date[1], 10),
            year: parseInt(date[2], 10)
          };
        } else {
          return {
            day: parseInt(date[0], 10),
            month: parseInt(date[1], 10),
            year: parseInt(date[2], 10)
          };
        }

    }
    return null;
  }
  // Set the display value format
  format(date: NgbDateStruct | NgbDate | null): string {
    if (this.translate.currentLang === 'en') {
      return date ? ( date.month < 10 ? ('0' + date.month) : date.month ) + this.DELIMITER +
                    ( date.day < 10 ? ('0' + date.day) : date.day )  + this.DELIMITER +
                      date.year : '';
    }
    else {
      return date ? ( date.day < 10 ? ('0' + date.day) : date.day ) + this.DELIMITER +
                    ( date.month < 10 ? ('0' + date.month) : date.month ) + this.DELIMITER +
                      date.year : '' ;
    }
  }


  // If date refactor is needed on component Init in order to display in placeholder/field
  // Split the object before putting it in the function, or write the parse function in the object property
  formatOnInit(object, yearIndex, monthIndex, dayIndex) {
    return { year: parseInt(object[yearIndex], 10), month: parseInt(object[monthIndex], 10), day: parseInt(object[dayIndex], 10) };
  }

  // Before sending date data to database, we need to put them back in a Date Type state ( YYYY-MM-dd )
  formatToSendinDB(object) {
    return object.year + '-' + object.month + '-' + object.day ;
  }

  rangeReformat(date: NgbDateStruct | NgbDate): string {
    return ( date.month < 10 ? ('0' + date.month) : date.month ) + this.DELIMITER +
      ( date.day < 10 ? ('0' + date.day) : date.day )  + this.DELIMITER +
      date.year;
  }

  // Check if the user langage is english or nah
  // If not english, it'll reformat the data in eng format
  // Use to make new Date for exemple
  makeEngDateFormat(s: string) {
    if (this.translate.currentLang !== 'en') {
      const tmpSplit = s.split(this.DELIMITER);
      return tmpSplit[1] +  this.DELIMITER + tmpSplit[0] + this.DELIMITER + tmpSplit[2];
    }
    return s;
  }

  // Get the number of days between 2 dates
  checkDatesDiff(firstDate, secondDate) {
    const FIRSTDATE = Date.UTC(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate());
    const SECONDDATE = Date.UTC(secondDate.getFullYear(), secondDate.getMonth(), secondDate.getDate());
    return Math.floor( (SECONDDATE - FIRSTDATE) ) / ( 1000 * 60 * 60 * 24 );
  }


  /**
   * Permet de récupérer les dates sélectionnées par l'utilisateur pour les afficher sur le calendrier.
   * @param startDate
   * @param endDate
   */
  public getDateSelectedByUser(startDate, endDate) {
    const result = {
      start : { year: null, month: null, day: null },
      end : { year: null, month: null, day: null },
    };
    const TMP_START = startDate.split('-');
    const TMP_END = endDate.split('-');

    result['start']['year'] = TMP_START[0];
    result['start']['month'] = TMP_START[1];
    result['start']['day'] = TMP_START[2];

    result['end']['year'] = TMP_END[0];
    result['end']['month'] = TMP_END[1];
    result['end']['day'] = TMP_END[2];
    return result;
  }


}
